import { render, staticRenderFns } from "./Navmenu.vue?vue&type=template&id=23efcd59&scoped=true&"
import script from "./Navmenu.vue?vue&type=script&lang=js&"
export * from "./Navmenu.vue?vue&type=script&lang=js&"
import style0 from "./Navmenu.vue?vue&type=style&index=0&id=23efcd59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23efcd59",
  null
  
)

export default component.exports